<template>
  <section style="position:relative" id="section">

  	<el-row class="statusRow">
      <el-button size="medium" type="primary" @click="goBack">返回</el-button>
    </el-row>
    <div  v-if="plist.length>0"  class="el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition" id="ta" style="width: 100%;">
	
							<div class="el-table__header-wrapper">
								<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;"  id="ta">
									<colgroup>
										<col name="el-table_3_column_28_column_29" width="15%">
										<col name="el-table_3_column_28_column_30" width="15%">
										<col name="el-table_3_column_28_column_31" width="10%">
										<col name="el-table_3_column_28_column_32" width="10%">
										<col name="el-table_3_column_28_column_33" width="5%">
										<col name="el-table_3_column_28_column_34" width="10%">
										<col name="el-table_3_column_28_column_35" width="10%">
										<col name="el-table_3_column_28_column_36" width="10%">
										<col name="el-table_3_column_28_column_36" width="5%">
										<col name="el-table_3_column_28_column_36" width="10%">
										<col name="gutter" width="0">
									</colgroup>
									<thead class="is-group has-gutter">
										<tr class="">
											<th colspan="10" rowspan="1" class="el-table_3_column_28  is-center  ">
												<div class="cell">结算对账单</div>
											</th>
										
										</tr>
										<tr class="">
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_29  is-center   is-leaf">
												<div class="cell">结算周期</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_30  is-center   is-leaf">
												<div class="cell">游戏名称</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_31  is-center   is-leaf">
												<div class="cell">渠道名称</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_32  is-center   is-leaf">
												<div class="cell">平台</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_33  is-center   is-leaf">
												<div class="cell">合作方式</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_34  is-center   is-leaf">
												<div class="cell">计价人数</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_35  is-center   is-leaf">
												<div class="cell">单价（元/个）</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_36  is-center   is-leaf">
												<div class="cell">应付金额（￥）</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_36  is-center   is-leaf">
												<div class="cell">类型</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_36  is-center   is-leaf">
												<div class="cell">操作</div>
											</th>
											
											
										</tr>
									</thead>

									<tbody class="el-table__body">
										<tr class="el-table__row" :class="index%2==1?'el-table__row--striped':''" v-for="item,index in plist">
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_29 is-center ">
												<div class="cell" @click=""><span >{{item.bill_sdate}}~{{item.bill_edate}}</span></div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_30 is-center ">
												<div class="cell">{{item.product_name}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_31 is-center ">
												<div class="cell">{{item.channel_name}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_32 is-center ">
												<div class="cell">{{item.platform}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_33 is-center ">
												<div class="cell" >{{item.ctype}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_34 is-center ">
												<div class="cell">{{item.num}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_35 is-center ">
												<div class="cell">{{item.atv}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												<div class="cell">{{item.amount}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												<div class="cell">{{item.type_text}}</div>
											</td>
							
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												<div class="cell blue" @click="$router.push({name:'成本日报详情',params:{issued_app_id:item.issued_app_id},query:{sdate:item.bill_sdate,edate:item.bill_edate,channel_id:item.channel_id}})">查看详情</div>
											</td>
											
										</tr>
										<tr>
											<td rowspan="1" colspan="10" class="el-table_3_column_28_column_36 is-center ">&nbsp;</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">结算类型	</td>
						    			<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{company.type==1?'企业':'个人'}}	</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">发票类型	</td>
						    			<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{bill.invoice_type==1?'普通发票':'增值发票'}}	</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">新增用户	</td>
						    			<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{bill.num}}	</td>
										</tr>
										<tr v-if="bill.offset==1">
											<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">抵扣金额	</td>
						    			<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{bill.offset_amount}}	</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center " v-if="company.type==1">结算金额	</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center " v-if="company.type==2">结算金额(扣去税点后金额)	</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{bill.bill_amount}}	</td>
										</tr>
										<tr>
												<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">结算金额（人民币大写）	</td>
						    				<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{bill.big_bill_amount}}	</td>
										</tr>
										
										<tr>
											<td rowspan="1" colspan="10" class="el-table_3_column_28_column_36 is-center ">&nbsp;</td>
										</tr>
										
										<tr>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">乙方公司 ：{{company.name}}</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{wecompany[0]}}</td>
							    	</tr>
							    	
							    	<tr>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">税号：{{company.social_credit_code}}</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{wecompany[3]}}</td>
							    	</tr>
							    	<tr>
								    <td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">注册地址：{{company.company_addr}}</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{wecompany[4]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">注册电话：{{company.company_phone}}</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{wecompany[8]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">开户银行 ：{{company.opening_bank}}</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{wecompany[1]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">银行 账号：{{company.receiving_account}}</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{wecompany[2]}}</td>
							    	</tr>
							    
							    	<tr>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">联系人：{{company.contact}}</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{wecompany[6]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">联系电话：{{company.phone}}</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{wecompany[7]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">邮寄地址：{{company.email_addr}}</td>
								    	<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{wecompany[5]}}</td>
							    	</tr>
										
										
										
										<!---->
									</tbody>
									
								</table>
							</div>

						</div>
    <!--列表-->
    <!--<el-table
      :data="plist"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="id"
      class="demo-table"
      v-if="plist.length>0"
    >
    <el-table-column label="结算对账单" align="center">        	
				<el-table-column prop="bill_date" label="结算周期" align="center" >
					<template slot-scope="scope">
						<span>{{scope.row.bill_sdate}}~{{scope.row.bill_edate}}</span>
	      </template>
				</el-table-column>
				<el-table-column prop="product_name" label="游戏名称" align="center" width="150px"></el-table-column>
				<el-table-column prop="channel_name" label="渠道名称" align="center" width="150px"></el-table-column>
				<el-table-column prop="platform" label="平台" align="center"></el-table-column>
				<el-table-column prop="type" label="合作方式" align="center" ></el-table-column>
				<el-table-column prop="num" label="新增人数" align="center" ></el-table-column>
				<el-table-column prop="unit" label="单价（元/个）" align="center" ></el-table-column>
				<el-table-column prop="amount" label="应收金额（￥）" align="center" ></el-table-column>
		</el-table-column>								      	
    </el-table>
    
    
    <div class="bill"  v-if="plist.length>0">
					      <el-row>
						    	<el-col :span="12">结算类型</el-col>
						    	<el-col :span="12">{{company.type==1?'企业':'个人'}}</el-col>
					    	</el-row>
					    	<el-row>
						    	<el-col :span="12">发票类型</el-col>
						    	<el-col :span="12">{{bill.invoice_type==1?'普通发票':'增值发票'}}</el-col>
					    	</el-row>
					    	<el-row>
						    	<el-col :span="12">新增用户</el-col>
						    	<el-col :span="12">{{bill.num}}</el-col>
					    	</el-row>
					    	<el-row>
						    	<el-col :span="12">税点</el-col>
						    	<el-col :span="12">{{bill.tax_point}}%</el-col>
					    	</el-row>
					    	<el-row>
						    	<el-col :span="12" v-if="company.type==1">结算金额</el-col>
						    	<el-col :span="12" v-if="company.type==2">结算金额(扣去税点后金额)</el-col>
						    	<el-col :span="12">{{bill.bill_amount}}</el-col>
					    	</el-row>
					    	<el-row>
						    	<el-col :span="12">结算金额（人民币大写）</el-col>
						    	<el-col :span="12">{{bill.big_bill_amount}}</el-col>
					    	</el-row>
				    </div>
    <div class="bill"  v-if="plist.length>0">
    	<el-row>
	    	<el-col :span="12">甲方公司 ：{{company.name}}</el-col>
	    	<el-col :span="12">{{wecompany[0]}}</el-col>
    	</el-row>
    	
    	<el-row>
	    	<el-col :span="12">税号：{{company.social_credit_code}}</el-col>
	    	<el-col :span="12">{{wecompany[3]}}</el-col>
    	</el-row>
    	<el-row>
	    <el-col :span="12">注册地址：{{company.company_addr}}</el-col>
	    	<el-col :span="12">{{wecompany[4]}}</el-col>
    	</el-row>
    	<el-row>
	    	<el-col :span="12">注册电话：{{company.company_phone}}</el-col>
	    	<el-col :span="12">{{wecompany[8]}}</el-col>
    	</el-row>
    	<el-row>
	    	<el-col :span="12">开户银行 ：{{company.opening_bank}}</el-col>
	    	<el-col :span="12">{{wecompany[1]}}</el-col>
    	</el-row>
    	<el-row>
	    	<el-col :span="12">银行 账号：{{company.receiving_account}}</el-col>
	    	<el-col :span="12">{{wecompany[2]}}</el-col>
    	</el-row>
    
    	<el-row>
	    	<el-col :span="12">联系人：{{company.contact}}</el-col>
	    	<el-col :span="12">{{wecompany[6]}}</el-col>
    	</el-row>
    	<el-row>
	    	<el-col :span="12">联系电话：{{company.phone}}</el-col>
	    	<el-col :span="12">{{wecompany[7]}}</el-col>
    	</el-row>
    	<el-row>
	    	<el-col :span="12">邮寄地址：{{company.email_addr}}</el-col>
	    	<el-col :span="12">{{wecompany[5]}}</el-col>
    	</el-row>
    	
   	</div>-->


		<div v-if="plist.length==0">
			暂无对账单
		</div>


    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { getBillDataDetail,  billDataStatus, billDataAdd ,selectCompany} from "../../api/api";
//import UploadImg from "./uploadImg.vue";

export default {
  components: {
//  UploadImg
  },
  data() {
    return {
      rules: {
       
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        bill_issued_data_id:0,
        bill_date:'',
      },
      plist: [],
      company:'',
      wecompany:[],
      bill:'',
      formLabelWidth: "100px",

      plog: [], //日志
      logDialog: false,




    };
  },
  watch: {

  },
  methods: {
		goBack(){
			this.$router.go(-1);
		},
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getBillDataDetail(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	this.company=res.data.company;
        	this.bill=res.data.bill;
        	this.wecompany=res.data.wecompany;
        	if(res.data.list&&res.data.list.length>0){
        		this.plist = res.data.list;
        		this.plist.sort(this.compareStatus);
        	}
          
        }
      });
    },
    compareStatus:function(val1, val2){
	    return val1.type_val - val2.type_val;
	  },
  },
  created() {
    let that = this;
  },
  mounted() {
  	
  	this.pdata.bill_issued_data_id= this.$route.params.index_id;
  	this.pdata.bill_date = this.$route.query.bill_date;
    this.getList();
  }
};
</script>
<style scoped lang="scss">
span.gn{
	color: #20A0FF;
	cursor: pointer;
}
.dialog {
  width: 800px;
}
.size {
  width: 100px;
  text-align: right;
  position: absolute;
  top: 20px;
  left: -100px;
  padding-right: 14px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
}
.bill{

	line-height: 48px;
	text-align: center;
	margin: 20px 0;
	overflow: hidden;
	border-top:1px solid #F2F6FC;
}
.bill .el-row{
	border-bottom:1px solid #F2F6FC;
	border-right:1px solid #F2F6FC;

	
}
.bill .el-row .el-col:first-child{
	
	border-right:1px solid #F2F6FC;
}
</style>

<style >
.demo-table .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    min-width: 200px;
    padding: 0 25px;
}
.demo-table .demo-table-expand label {

    color: #99a9bf;
}
.el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
}
.el-upload-list__item {
  line-height: 0;
}
.selectRow {
  min-width:1200px;padding:15px;background: #fff;
}
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.gameIcon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 220px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pageRow {
  min-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  left: 0;
  bottom: -20px;
  z-index: 1000;
}
@media only screen and (max-width: 767px) {
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 100%;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
.blue{
	color: #0082E6;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// dataDetail.vue?08f65382